export abstract class ApplicationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ApplicationError";
  }
}

export class NotFoundError extends ApplicationError {
  constructor(message: string) {
    super(message);
    this.name = "NotFoundError";
  }
}

export class UnauthorizedError extends ApplicationError {
  constructor(message: string) {
    super(message);
    this.name = "UnauthorizedError";
  }
}

export class UnauthenticatedError extends ApplicationError {
  constructor(message: string) {
    super(message);
    this.name = "UnauthenticatedError";
  }
}

export class RedirectError extends ApplicationError {
  path: string;

  constructor(path: string) {
    super(`Redirect to ${path}`);
    this.name = "RedirectError";
    this.path = path;
  }
}
